import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";
import {
	DashboardLayout,
} from "@/components/dashboard/DashboardLayout";
import { DocsSidebar, PAGE_TOC, DEFAULT_TOC } from "@/routes/help";

export const Route = createFileRoute("/dashboard/help")({
	component: DashboardHelpLayout,
});

function DashboardHelpLayout() {
	const matches = useMatches();
	const lastMatch = matches[matches.length - 1];
	const isHubRoot =
		lastMatch?.fullPath === "/dashboard/help/" ||
		lastMatch?.fullPath === "/dashboard/help";
	const currentSlug =
		lastMatch?.fullPath.replace("/dashboard/help/", "") || null;

	if (isHubRoot) {
		return (
			<DashboardLayout>
				<Outlet />
			</DashboardLayout>
		);
	}

	const toc = PAGE_TOC[currentSlug ?? ""] ?? DEFAULT_TOC;

	return (
		<DashboardLayout>
			<div className="grid gap-8 lg:grid-cols-[200px_minmax(0,1fr)_180px]">
				{/* Docs sub-nav */}
				<aside
					className="hidden lg:block sticky top-4 self-start"
					style={{ borderRight: "1px solid rgba(255,255,255,0.08)", paddingRight: "1.5rem" }}
				>
					<DocsSidebar currentSlug={currentSlug} basePath="/dashboard/help" />
				</aside>

				{/* Content */}
				<main id="main-content" className="min-w-0">
					<Outlet />
				</main>

				{/* ToC */}
				<aside className="hidden lg:block sticky top-4 self-start">
					<p
						className="text-[10px] font-bold uppercase tracking-[0.1em] mb-4"
						style={{
							fontFamily: "inherit",
							color: "#6B3FF2",
						}}
					>
						On this page
					</p>
					<nav aria-label="Help navigation" className="space-y-2 text-xs" style={{ color: "var(--km-on-surface-muted)" }}>
						{toc.map((link) => (
							<a
								key={link}
								href={`#${link.toLowerCase().replace(/\s+/g, "-")}`}
								className="block py-1 transition-colors hover:text-[#6B3FF2] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0072f5]/60"
								onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.textDecoration = "underline dotted"; }}
								onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.textDecoration = "none"; }}
								onFocus={(e) => { (e.currentTarget as HTMLElement).style.textDecoration = "underline dotted"; }}
								onBlur={(e) => { (e.currentTarget as HTMLElement).style.textDecoration = "none"; }}
							>
								{link}
							</a>
						))}
					</nav>
				</aside>
			</div>
		</DashboardLayout>
	);
}
